const Performance = () => {
  return (
    <div className="min-h-screen flex justify-center items-center">
      <h1 className="text-2xl">TO-DO</h1>
    </div>
  );
};

export default Performance;
